module.exports = __webpack_public_path__ + "img/File-excel.5c452f97.svg";